





















import Vue, { PropOptions } from 'vue';
import NOC from '@/class/common/const';
import * as models from '@/class/models/views/graph';

export default Vue.extend({
  name: 'MaterialsListV2',
  props: {
    title: String,
    description: String,
    select: Array as PropOptions<models.IDomain[]>,
    materials: Array,
  },
  data() {
    return {
      selectMaterials: [] as models.IDomain[],
    };
  },
  methods: {
    onClickMaterial(material: models.IDomain) {
      this.$emit('select', material);
    },
    classMaterialButton(material: models.IDomain) {
      return {
        selected:  this.select.filter((v) => (v.id === material.id) ).length > 0 ,
        darken: this.select.filter((v) => (v.reject.indexOf(material.id) !== -1)).length > 0 ,
      };
    },
  },
});

